import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "section is-full-page-height",
  style: {"padding-top":"2rem"}
}
const _hoisted_2 = {
  class: "report-viewer-height",
  id: "report-viewer"
}
const _hoisted_3 = { class: "columns report-viewer-height" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = ["action"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["name", "id", "value"]
const _hoisted_8 = {
  style: {"display":"none","width":"100%","height":"100%"},
  id: "report-frame",
  name: "report-frame",
  ref: "reportFrame"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_loading = _resolveComponent("o-loading")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_o_loading, {
        active: _ctx.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_o_icon, {
            pack: "fa",
            icon: "spinner",
            size: "large",
            spin: "",
            variant: "primary"
          })
        ]),
        _: 1
      }, 8, ["active"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            style: {"display":"none"},
            id: "report-frame-parameters",
            action: _ctx.actionComputed,
            target: "report-frame",
            method: "post",
            ref: "reportFrameParameters"
          }, [
            (_ctx.Parameters != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Parameters, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.name
                    }, [
                      _createElementVNode("input", {
                        type: "text",
                        name: item.name,
                        id: item.name,
                        value: item.value
                      }, null, 8, _hoisted_7)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5),
          _createElementVNode("iframe", _hoisted_8, "\r\n                    ", 512)
        ])
      ])
    ])
  ]))
}